export const SHOW_PREVIEW_PDF = 'SHOW_PREVIEW_PDF'
export const HIDE_PREVIEW_PDF = 'HIDE_PREVIEW_PDF'
export const DATA_PREVIEW_PDF = 'DATA_PREVIEW_PDF'

export interface ShowPreviewPdf {
  type: typeof SHOW_PREVIEW_PDF
  payload: string
}

export interface HidePreviewPdf {
  type: typeof HIDE_PREVIEW_PDF
  payload: null
}

export interface DataPreviewPdf {
  type: typeof DATA_PREVIEW_PDF
  payload: any
}

export interface State {
  visiblePreviewPdf: string | null
}

export const initialState: State = {
  visiblePreviewPdf: null,
}

export type Actions = ShowPreviewPdf | HidePreviewPdf
